import "../../styles/BoatReceipt.scss";
import _ from "lodash";
import { withSnackbar } from "notistack";
import React, { Fragment, PureComponent } from "react";
// import ReactNotification from "react-notifications-component";
// import { hotelBooking } from "../../services/hotel";
import { paymentGatwayURI } from "../../config.json";
import { Loader } from "../common/forms/Loading/Loader";
import { ErrorModal } from "../common/forms/ErrorModal";
// import { addBookingRescheduling } from "../../services/bookingHistory";
import { addNotification } from "../common/forms/Methods/index";
import { subDirectory } from "../../config.json";
import { getLocalStorageValues } from "../../services/authService";
import moment from "moment";
import { bookingAfterTransaction } from "../../services/boatListService";


class Payment extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      transactionStatus: "",
      orderId: "",
      paymentMode: "",
      failureReason: "",
      loading: true,
      isNOpen: false,
    };
    this.notificationDOMRef = React.createRef();
  }

  componentDidMount = async () => {
    console.log(this.props);
    setTimeout(
      function () {
        this.setState({ loading: false });
      }.bind(this),
      3000
    );
  };

  /**
   * To open a payment gate way
   */
  paymentLoad = () => {
    const { data } = this.props;
    try {
      return (
        <iframe
          title="Payment"
          id="paymentFrame"
          ref={"paymentFrame"}
          className="payment-frame"
          src={`${paymentGatwayURI}/initiatePayment?amt=2000&email=aa@gmail.com&mobileno=9566700351`}
          onLoad={this.iframeLoad}
        ></iframe>
      );
    } catch (error) {}
  };

  iframeLoad = async (e) => {
    try {
      var ipath = document.getElementById("paymentFrame");
      console.log(ipath,"ipath")
      console.log("content",ipath.contentWindow)
      // const frameURL = ipath.contentWindow.location.href;
      const frameURL = ipath.src
      console.log(frameURL,`${paymentGatwayURI}/ccavRequestHandler`,frameURL === `${paymentGatwayURI}/ccavRequestHandler`)
      setTimeout(
        function () {
          this.setState({ loading: false });
        }.bind(this),
        600
      );
      if (frameURL === `${paymentGatwayURI}/ccavRequestHandler`) {
        // return this.bookBoat();
        console.log("request")
      }
      if (frameURL === `${paymentGatwayURI}/ccavResponseHandler`) {
        // if (this.props.location.state.Reschedule === true) {
        //   return this.reschedule();
        // } else {
          console.log("response")
          return this.bookBoat();
        // }
      }
    } catch (error) {
      //  this.bookBoat();
      // if (this.props.location.state.Reschedule === true) {
      //   return this.reschedule();
      //   await this.setState({ isNOpen: true });
      //   setTimeout("location.href = '/bookingHistory'", 100);
      //   if (this.state.isNOpen === true) {
      //     setTimeout(
      //       function () {
      //         this.setState({ isNOpen: false });
      //       }.bind(this),
      //       1000
      //     );
      //   }
      // } else {
      //   return this.bookHotel();
      //   await this.setState({ isNOpen: true });
      //   if (this.state.isNOpen === true) {
      //     setTimeout(
      //       function () {
      //         this.setState({ isNOpen: false });
      //       }.bind(this),
      //       1000
      //     );
      //   }
      //   setTimeout(`location.href="/hotel"`);
      // }
    }
  };

  bookBoat = async () => {
    console.log("858585")
    try {
      const {
        location: {
          state: { TransactionId, BoatHouseId },
        },
      } = this.props;
      let afterData = {
        TransactionNo: this.props.history.location.state.bookingid,
        UserId: `${getLocalStorageValues("UserId")}`,
        MobileNo: `${getLocalStorageValues("MobileNo")}`,
        EmailId: `${getLocalStorageValues("EmailId")}`,
        BankReferenceNo: "SSSS12433",
        BookingType: "B",
        BoatHouseId: this.props.history.location.state.BoatHouseId,
        BookingMedia: "PW",
        OrderStatus: "Success",
        ModuleType: "Boating",
      };
      this.setState({ loading: false });
      const ares = await bookingAfterTransaction(afterData);
      console.log(ares, afterData);
      let bid, bookid
      if (ares.data.StatusCode === 1) {
        bid = ares.data.Response
        bookid=  bid.replace(/[^\d.-]/g, '')
        this.setState({Bookid:bookid})
      }

      const { isNOpen } = this.state;
      if (ares.data.StatusCode === 1) {
        this.setState({ Status: "Successfully", isNOpen: true });
        await addNotification(this.props, "Booked Successfully", "success");
        if (isNOpen === true) {
          setTimeout(
            function () {
              this.setState({ isNOpen: false });
            }.bind(this),
            2000
          );
        }
        return this.redirectTo("forward");
      } else if (ares.data.StatusCode === 0) {
        this.setState({ Status: "Failed", isNOpen: true });
        await addNotification(
          this.props,
          "Something went wrong please try again after some time",
          "error"
        );
        if (isNOpen === true) {
          setTimeout(
            function () {
              this.setState({ isNOpen: false });
            }.bind(this),
            2000
          );
        }
      }
    } catch (err) { }
  };

  redirectTo = async () => {
    const {
      location: {
        state: {
          BoatHouseId,
        },
      },
    } = this.props;
    // this.props.history.push({
    //   pathname: `${subDirectory}/booking-receipt`,
    //   state: {
    //     BoatHouseId: this.props.history.location.state.BoatHouseId,
    //     BookingId: this.state.Bookid,
    //     BookingDate: this.props.history.location.state.startDate
    //   },
    // });
    window.location.replace(
      `${subDirectory}/booking-receipt?BoatHouseId=${this.props.history.location.state.BoatHouseId}&BookingId=${this.state.Bookid}&BookingDate=${this.state.BookingDate}`
    );
  };

  // reschedule = async () => {
  //   const {
  //     location: {
  //       state: {
  //         HotelId,
  //         City,
  //         BookingId,
  //         BookingOldDate,
  //         BookingNewDate,
  //         Reschedule,
  //         Comments,
  //       },
  //     },
  //   } = this.props;
  //   let data1 = {
  //     HotelId: HotelId,
  //     BookingId: BookingId,
  //     BookingOldDate: BookingOldDate,
  //     BookingNewDate: BookingNewDate,
  //     Comments: Comments,
  //     RescheduleDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
  //     CreatedBy: getLocalStorageValues("CREATEDBY"),
  //   };
  //   let response = await addBookingRescheduling(data1);
  //   await this.setState({ BookingNewDate: data1.BookingNewDate });
  //   if (response.data.status === true) {
  //     await this.nextPage1(true, response.data.message);
  //     // this.setState({ loading: false });
  //     // return addNotification(
  //     //   this.props,
  //     //   "Rescheduled  SuccessFully",
  //     //   "success"
  //     // );
  //   } else {
  //     this.setState({ loading: false });
  //     this.nextPage1(false, response.data.message);
  //   }
  // };

  // nextPage1 = async (status, message) => {
  //   this.props.history.push({
  //     pathname: `${subDirectory}/bookingHistory`,
  //     state: {
  //       BookingId: this.props.location.state.BookingId,
  //       BookingNewDate: this.props.location.state.BookingNewDate,
  //     },
  //     Notification: message,
  //     variant: status ? "success" : "warning",
  //   });
  // };

  render() {
    const { handleBack } = this.props;
    const { loading } = this.state;
    return (
      <Fragment>
        {/* <ReactNotification ref={this.notificationDOMRef} /> */}
        <Loader fullPage loading={loading} />
        <ErrorModal
          onClick={this.notifiysubmit}
          label="Hotel"
          isOpen={this.state.isNOpen}
          {...this.props}
          Status={this.state.Status}
        />
        {this.paymentLoad()}
      </Fragment>
    );
  }
}

export default withSnackbar(Payment);
